<crm-auto-complete
  [(value)]="selectedBank"
  (valueChange)="selectedBankChange.emit($event)"
  [isError]="isError"
  [class]="class"
  [styleClass]="styleClass"
  [suggestions]="banks"
  [field]="field"
  [inputStyle]="inputStyle"
  [virtualScroll]="true"
  [virtualScrollItemSize]="60"
  [appendTo]="appendTo"
  (completeMethod)="bankSearch.emit($event.query)">
  <ng-template
    #itemTemplate
    let-bank="item">
    <div *ngIf="toBank(bank) as bank">
      <div>{{ bank.name }}</div>
      <div class="frm-color-green">{{ bank.bik }}</div>
    </div>
  </ng-template>
</crm-auto-complete>
